import { get, post } from "../utility/fetch-util";

export const getLastOdo = async (vehicleId, progress) => {
    return get('/api/drivers/vehicle/' + vehicleId + '/lastOdo', null, progress);
}

export const submitOdo = async (vehicleId, reading, progress) => {
    return post('/api/drivers/vehicle/' + vehicleId + '/newOdo', {"reading" : reading}, null, progress);
}

export const getCurrentEvent = async (vehicleId, progress) => {
    return get('/api/drivers/vehicle/' + vehicleId + '/currentEvent', null, progress);
}

export const getAlerts = async (vehicleId, progress) => {
    return get('/api/drivers/vehicle/' + vehicleId + '/alerts', null, progress);
}

export const getOpenTravelRequests = async (vehicleId, progress) => {
    return get('/api/drivers/vehicle/' + vehicleId + '/openTravelRequests', null, progress);
}

export const submitTravelRequest = async (vehicleId, request, progress) => {
    return post('/api/drivers/vehicle/' + vehicleId + '/newTravelRequest', null, request, progress);
}

export const getVehicleDetails = async (vehicleId, progress) => {
    return get('/api/drivers/vehicle/' + vehicleId + '/details', null, progress);
}

export const getDamageAreasForVehicle = async (vehicleId, progress) => {
    return get('/api/inspections/vehicles/' +vehicleId + '/damage-areas', null, progress);
}

export const getVehicleDamageDetails = async (vehicleId, progress) => {
    return get('/api/inspections/vehicles/' + vehicleId + '/damages', null, progress);
}

export const getVehicleAncillaries = async (vehicleId, progress) => {
    return get('/api/drivers/vehicle/' + vehicleId + '/ancillaries', null, progress);
}

export const getAncillaryLastReading = async (vehicleId, vehicleAncillaryId, progress) => {
    return get('/api/drivers/vehicle/' + vehicleId + '/' + vehicleAncillaryId + '/lastReading', null, progress);
}

export const getVehicleDefects = async (vehicleId, progress) => {
    return get('/api/drivers/vehicle/' + vehicleId + '/defects', null, progress);
}

/**
 * Get a vehicle diagram
 */
export const getVehicleTyresSvg = async (vehicleId, progress) => {
    return get('/api/drivers/tyre/' + vehicleId, null, progress);
}

/**
 * Gets vehicle documents
 */
export const getVehicleFiles = async (vehicleId, currentContractLineId, currentContractId, progress) => {
    return get('/api/drivers/vehicle/vehicleId/' + vehicleId + '/currentContractLineId/' + currentContractLineId + '/currentContractId/' + currentContractId + '/files', null, progress);
}